import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DataOptions, DependOnOption, DisabledType } from '../common'

export class RadioDef {
  key?: string = uuid()
  type: 'radio' = 'radio'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: RadioOptions = new RadioOptions()
  rules?: Rule[]
}

export class RadioOptions {
  defaultValue?: string | number
  disabled?: DisabledType = false
  labelWidth?: string | number
  required?: boolean = false
  type?: 'normal' | 'button' = 'normal'
  desc?: {}
  options?: DataOptions = {}
  onRadioChange?: (value: any, form: Record<string, any>) => void
}
